import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadAdministradora = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      width: "40px",
      align: "left",
    },
    {
      title: "Administradoras",
      align: "left",
      width: "90%",
    },
    {
      title: "Ativo",
      align: "center",
      width: "100px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
